import Cookies from "js-cookie";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const runTimeline = (el, shouldPlayFullAnimation = true) => {
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const panelContainer = el.querySelector(".animation-panel-container");

  gsap.set(el.querySelectorAll(".intro-block > *"), { opacity: 0, y: "40%" });
  gsap.set(el.querySelector(".item-blocks"), { opacity: 0 });
  gsap.set(el.querySelectorAll(".item-end-block"), { opacity: 0, y: "40%" });

  const itemBlocks = el.querySelector(".item-blocks");
  const blocks = el.querySelectorAll(".item-animate-block");

  blocks.forEach((block) => {
    const title = block.querySelector(".item-animate-block-title");

    gsap.set(title, {
      opacity: 0,
      transformOrigin: "center center",
      transform: `scale(6)`,
    });

    gsap.set(block.querySelectorAll(".item-animate-block-part"), {
      opacity: 0,
    });
  });

  panelContainer.setAttribute("data-animation-ready", true);

  const itemBlocksTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      start: () => {
        if (isMobile) {
          return "center center";
        }

        const siteHeaderHeight =
          parseInt(getComputedStyle(document.documentElement).getPropertyValue("--site-header-stuck-height")) + 2;

        return `top ${siteHeaderHeight}px`;
      },
      once: true,
      markers: false,
    },
  });

  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      start: () => {
        const siteHeaderHeight =
          parseInt(getComputedStyle(document.documentElement).getPropertyValue("--site-header-stuck-height")) + 2;

        return `top ${siteHeaderHeight}px`;
      },
      once: true,
      markers: false,
    },
  });

  timeline.to(el.querySelectorAll(".intro-block > *"), { opacity: 1, y: 0, stagger: 0.2, duration: 1 });

  itemBlocksTimeline.to(el.querySelector(".item-blocks"), {
    opacity: 1,
    duration: 1.5,
    delay: isMobile ? 0 : 0.5,
  });

  if (shouldPlayFullAnimation) {
    blocks.forEach((block) => {
      const title = block.querySelector(".item-animate-block-title");

      itemBlocksTimeline.to(title, {
        opacity: 1,
        transform: "scale(1) translate(0, 0)",
        ease: "expo",
        duration: 0.8,
      });

      itemBlocksTimeline.to(
        block.querySelectorAll(".item-animate-block-part"),
        {
          opacity: 1,
          y: 0,
          ease: "ease",
          duration: 0.4,
          stagger: 0.2,
        },
        "<50%",
      );

      itemBlocksTimeline.to(block, {
        opacity: 0,
        duration: 0.2,
        delay: 1.5,
      });
    });
  }

  itemBlocksTimeline.to(el.querySelectorAll(".item-end-block"), {
    opacity: 1,
    y: 0,
    stagger: 0.3,
  });
};

document.querySelectorAll(".element-calloutcontentlist").forEach((el) => {
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const elementContainer = el.querySelector(".element-container");

    let shouldPlayFullAnimation = true;

    const cookieName = `biotouch_elementanimation-${el.id}`;

    if (elementContainer.dataset.cookie !== undefined) {
      if (Cookies.get(cookieName)) {
        shouldPlayFullAnimation = false;
      }
    }

    runTimeline(el, shouldPlayFullAnimation);
  }
});
